// A video's poster and its still are the same picture. Both are asked for over whatever scheme the
// stored url carries, and an `http://` one on an https page is refused as mixed content -- it simply
// does not paint, with nothing said. The scheme is dropped so the browser asks over the page's own.
export const resolveThumbSrc = video =>
  (video?.thumbnailUrl || video?.thumbnail?.original?.url || '').replace(/http:\/\//gi, '//')

export const calcBadData = ({ answer }) => {
  const isBadArray = Array.isArray(answer?.badData) && answer.badData[0] === true

  const isBadFlag = answer?.badData === true

  const hasError = Boolean(answer?.err)

  const isEmptyObject = answer && !Object.keys(answer).length

  return isBadArray || isBadFlag || hasError || isEmptyObject
}

export const isComponentOn = (components, flag) =>
  !components || components?.[flag] === undefined || true === components?.[flag]
